import React from 'react';
interface InputProps {
  type?: string;
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  error?: string;
  icon?: React.ReactNode;
  fullWidth?: boolean;
  className?: string;
  required?: boolean;
  name?: string;
  id?: string;
}
const Input: React.FC<InputProps> = ({
  type = 'text',
  placeholder,
  value,
  onChange,
  label,
  error,
  icon,
  fullWidth = false,
  className = '',
  required = false,
  name,
  id
}) => {
  const widthClass = fullWidth ? 'w-full' : '';
  const errorClass = error ? 'border-red-500 dark:border-red-400' : 'border-gray-300 dark:border-gray-600';
  return <div className={`mb-4 ${widthClass} ${className}`} data-id="element-47">
      {label && <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" htmlFor={id || name} data-id="element-48">
          {label}
          {required && <span className="text-red-500 ml-1" data-id="element-49">*</span>}
        </label>}
      <div className="relative" data-id="element-50">
        {icon && <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-500 dark:text-gray-400" data-id="element-51">
            {icon}
          </div>}
        <input type={type} id={id || name} name={name} placeholder={placeholder} value={value} onChange={onChange} required={required} className={`
            block rounded-lg px-4 py-2.5
            bg-white dark:bg-gray-800
            text-gray-900 dark:text-gray-100
            border ${errorClass}
            focus:outline-none focus:ring-2 focus:ring-teal-500 dark:focus:ring-teal-400 focus:border-transparent
            placeholder-gray-400 dark:placeholder-gray-500
            transition-colors duration-200
            ${icon ? 'pl-10' : ''}
            ${widthClass}
          `} data-id="element-52" />
      </div>
      {error && <p className="mt-1 text-sm text-red-500 dark:text-red-400" data-id="element-53">{error}</p>}
    </div>;
};
export default Input;